import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { getConditionColor } from './sp';
import SparePartCard from './SparePartCard.vue';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BundledPartsList',
    props: {
        primarySparePart: {},
        config: {},
        checkInQuote: { type: Function }
    },
    emits: ["toggleSparePart", "update:primarySparePart"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isVisible = computed(() => !!props.primarySparePart);
        function close() {
            emit('update:primarySparePart', null);
        }
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                "model-value": isVisible.value,
                "onUpdate:modelValue": close,
                "max-width": "600"
            }, {
                default: _withCtx(({ isActive }) => [
                    (_ctx.primarySparePart)
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 0,
                            title: _ctx.primarySparePart.part_number,
                            subtitle: _ctx.primarySparePart.part_number_alt_1
                        }, {
                            prepend: _withCtx(() => [
                                _createVNode(_component_v_chip, {
                                    color: _unref(getConditionColor)(_ctx.primarySparePart.condition_code),
                                    variant: "tonal"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.primarySparePart.condition_code), 1)
                                    ]),
                                    _: 1
                                }, 8, ["color"])
                            ]),
                            append: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                    icon: "mdi-close",
                                    onClick: close,
                                    variant: "text"
                                })
                            ]),
                            default: _withCtx(() => [
                                _createVNode(_component_v_container, { class: "bg-warmLightGray primaryContainer" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(SparePartCard, {
                                                            sparePart: _ctx.primarySparePart,
                                                            config: _ctx.config,
                                                            checkInQuote: _ctx.checkInQuote,
                                                            showBundled: false,
                                                            onToggleSparePart: _cache[0] || (_cache[0] = ($event) => (emit('toggleSparePart', $event)))
                                                        }, null, 8, ["sparePart", "config", "checkInQuote"])
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_divider)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.primarySparePart.bundled, (bundledSpart) => {
                                            return (_openBlock(), _createBlock(_component_v_row, {
                                                key: bundledSpart.id
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(SparePartCard, {
                                                                sparePart: bundledSpart,
                                                                config: _ctx.config,
                                                                checkInQuote: _ctx.checkInQuote,
                                                                primarySparePart: _ctx.primarySparePart,
                                                                onToggleSparePart: _cache[1] || (_cache[1] = ($event) => (emit('toggleSparePart', $event)))
                                                            }, null, 8, ["sparePart", "config", "checkInQuote", "primarySparePart"])
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1024));
                                        }), 128))
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["title", "subtitle"]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["model-value"]));
        };
    }
});
